module.exports = __webpack_public_path__ + "src/img/whattodo1.jpg?3c6d706956fa12c543b0d302bc0ecad2";


//////////////////
// WEBPACK FOOTER
// ./src/img/whattodo1.jpg
// module id = 212
// module chunks = 0